export interface Dashboard {
  id: string;
  name: string;
  embedUrl: string;
  description: string;
  defaultTab: boolean;
  parameters: string[];
}

export interface DashboardConfig {
  dashboards: Dashboard[];
}

const dashboardConfig: DashboardConfig = {
  dashboards: [
    {
      id: 'audit-report',
      name: '',
      embedUrl:
        'https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/764946308314/dashboards/22790388-5279-4409-aff4-6b55e82aba51?directory_alias=amazonbi',
      description: '',
      defaultTab: true,
      parameters: ['BusinessUnit'],
    },
  ],
};

export default dashboardConfig;
